import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../lib/request";
import { unwrapHotelSearchList } from "../../lib/utils/hotelSearchMappers";

export const searchSubBrandHotels = createAsyncThunk(
  "organization/searchSubBrandHotels",
  async (
    { brandId, query = "", page = 0, size = 300 },
    { rejectWithValue }
  ) => {
    try {

      if (!brandId) return [];

      let url = `/authn/sub-brands/${brandId}/search?page=${page}&size=${size}`;

      if (query?.trim()) {
        url += `&q=${encodeURIComponent(query.trim())}`;
      }


      const response = await get(url, null, {
        skipAuth: false,
      });

      return unwrapHotelSearchList(response);

    } catch (error) {

      console.error("Sub-brand API error:", error);

      return rejectWithValue(error.message);

    }
  }
);


const organizationSlice = createSlice({
  name: "organization", 

  initialState: {
    subBrands: [],
    loadingSubBrands: false,
    error: null,
  },

  reducers: {

    clearSubBrands: (state) => {

      state.subBrands = [];
      state.loadingSubBrands = false;
      state.error = null;

    },

  },

  extraReducers: (builder) => {

    builder

      .addCase(searchSubBrandHotels.pending, (state) => {

        state.loadingSubBrands = true;
        state.error = null;

      })

      .addCase(searchSubBrandHotels.fulfilled, (state, action) => {

        state.loadingSubBrands = false;
        state.subBrands = action.payload || [];

      })

      .addCase(searchSubBrandHotels.rejected, (state, action) => {

        state.loadingSubBrands = false;
        state.error = action.payload;

      });

  },

});

export const { clearSubBrands } = organizationSlice.actions;

export default organizationSlice.reducer;
